import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';

const InfoModal = ({ handleClose }) => {
    return (
        <>
            <Modal className="dk-subscriptionInfo-modal" centered show={true} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Plan Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus, architecto quo. Eos impedit atque dolor, accusantium vel officia alias neque dolorum nulla rerum odio maxime est, sunt magnam ipsam! Laboriosam!
                </Modal.Body>
            </Modal>
        </>
    )
}

export default InfoModal;
